import { getColumnId, TableColumn } from '@/components/ui/table/table.types'

// Note: a hidden column's sort indicator and "Clear sorting" action disappear with it, so the
// sort has to be dropped when the column it is applied to stops being visible.
export const isSortedColumnHidden = <T>(
  columns: TableColumn<T>[],
  visibleColumnIds: string[],
  sortBy?: string | null,
): boolean => {
  if (!sortBy) return false

  const columnsBySortKey = new Map(columns.map((col) => [col.sortKey, col]))
  const visibleIds = new Set(visibleColumnIds)
  const sortedColumn = columnsBySortKey.get(sortBy)

  return !!sortedColumn && !visibleIds.has(getColumnId(sortedColumn))
}
